import { createSlice } from '@reduxjs/toolkit'

import { fetchSite } from 'redux/thunks/Site'
import { ISiteProps } from 'types/Site'

const initialState: ISiteProps = {
  filter: 'general',
  site: {
    id: '',
    locale: 'en',
    adminLocale: 'en',
    createdAt: '',
    region: '',
    sharedUrl: {
      link: '',
      password: '',
    },
  },
  fetching: false,
  doneFetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
  launching: false,
  launchingError: '',
  errors: {},
}

export const site = createSlice({
  name: 'site',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchSite?.pending?.toString()]: (state) => {
      state.fetching = true
    },
    [fetchSite?.fulfilled?.toString()]: (state, action) => {
      state.site = action.payload
      state.fetching = false
      state.doneFetching = true
    },
    [fetchSite?.rejected?.toString()]: (state, action) => {
      state.fetchError = action.payload
      state.fetching = false
      state.doneFetching = false
    },
  },
})

export default site.reducer
